import styled from 'styled-components';

const IconButton = styled.button`
    color: ${ ({ theme }) => theme.semanticColor.next.text.primary };
    border-radius: 50%;
    border: 1px solid ${ ({ theme }) => theme.semanticColor.next.inputBorder };
    background: transparent;
    width: 36px;
    height: 36px;
    padding: 10px;
    cursor: pointer;

    :hover {
        background-color: ${ ({ theme }) => theme.semanticColor.next.action.hover };
    }

    svg {
        stroke: ${ ({ theme }) => theme.semanticColor.next.action.active }
    }
`;

export default IconButton;
